// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for /users/home for premium admin.
 * People tab. */

#peopleTabBatchEditModal .cancelAndApply .cancel {
  margin-right: 2rem;
}

/*!* Profile editing */
/** /users/edit/<userId>/ *!*/
/*!* Make this container inline block so it's horizontal with the */
/** save and cancel buttons *!*/
/*.premiumAdminEditUserMenu .deactivateUserContainer {*/
/*display: inline-block;*/
/*}*/

.premiumAdminEditUserMenu .fullNameHeader {
  display: inline-block;
  color: black;
  font-family: 'Rockwell';
  font-weight: bold;
}

.premiumAdminEditUserMenu .fullNameHeaderSubtitle {
  display: inline-block;
  font-size: 14px;
}

/* People tab batch edit modal results list */
.taModal .resultsList,
.transcriptAddModal .resultsList {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.taModal .resultsList ol li,
.transcriptAddModal .resultsList ol li {
  padding-left: 2rem;
}

.taModal .resultsList .userList {
  height: 40vh;
  overflow-y: scroll;
}
.taModal .resultsList .okButtonContainer {
  margin-top: 2rem;
  width: 12rem;
  margin-left: auto;
  margin-right: auto;
}

.taModal .resultsList .imageContainer,
.transcriptAddModal .resultsList .imageContainer {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}

.taModal .resultsList .imageContainer p,
.transcriptAddModal .resultsList .imageContainer p {
  margin-top: 2rem;
  margin-bottom: 0;
  text-align: left;
}

.taUsers .spinner {
  margin: 0 auto;
}

.csh-icon {
  margin-right: 4rem;
  width: 3.5rem;
  height: 3.5rem;
  margin-top: 0.8rem;
}

.checkbox-remove {
  margin: 0px !important;
  display: inline-block;
  vertical-align: middle;
}

.retake-limit-fields {
  width: 60px !important;
  display: inline !important;
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/users/admin.css"],"names":[],"mappings":"AAAA;gBACgB;;AAEhB;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB,6BAA6B;AAC7B,mEAAmE;AACnE,+BAA+B;AAC/B,uDAAuD;AACvD,yBAAyB;AACzB,IAAI;;AAEJ;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;AACnB","sourcesContent":["/* Styling for /users/home for premium admin.\n * People tab. */\n\n#peopleTabBatchEditModal .cancelAndApply .cancel {\n  margin-right: 2rem;\n}\n\n/*!* Profile editing */\n/** /users/edit/<userId>/ *!*/\n/*!* Make this container inline block so it's horizontal with the */\n/** save and cancel buttons *!*/\n/*.premiumAdminEditUserMenu .deactivateUserContainer {*/\n/*display: inline-block;*/\n/*}*/\n\n.premiumAdminEditUserMenu .fullNameHeader {\n  display: inline-block;\n  color: black;\n  font-family: 'Rockwell';\n  font-weight: bold;\n}\n\n.premiumAdminEditUserMenu .fullNameHeaderSubtitle {\n  display: inline-block;\n  font-size: 14px;\n}\n\n/* People tab batch edit modal results list */\n.taModal .resultsList,\n.transcriptAddModal .resultsList {\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n\n.taModal .resultsList ol li,\n.transcriptAddModal .resultsList ol li {\n  padding-left: 2rem;\n}\n\n.taModal .resultsList .userList {\n  height: 40vh;\n  overflow-y: scroll;\n}\n.taModal .resultsList .okButtonContainer {\n  margin-top: 2rem;\n  width: 12rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.taModal .resultsList .imageContainer,\n.transcriptAddModal .resultsList .imageContainer {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.taModal .resultsList .imageContainer p,\n.transcriptAddModal .resultsList .imageContainer p {\n  margin-top: 2rem;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.taUsers .spinner {\n  margin: 0 auto;\n}\n\n.csh-icon {\n  margin-right: 4rem;\n  width: 3.5rem;\n  height: 3.5rem;\n  margin-top: 0.8rem;\n}\n\n.checkbox-remove {\n  margin: 0px !important;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.retake-limit-fields {\n  width: 60px !important;\n  display: inline !important;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
